import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';

@Injectable()
export class SoudotecItemsInputService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doFindArticlesAction(queryParams: any) {
        return this._httpClient.post<any[]>(this._apiService.endPoints.doFindArticlesAction_Soudotec, queryParams)
            .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')))
            .toPromise();
    }
}